import global from "./global.js";
import { maybe } from "./maybe.js";
export default ("__DEV__" in global ? Boolean(global.__DEV__) : maybe(function () { return process.env.NODE_ENV; }) !== "production");
//# sourceMappingURL=DEV.js.map